import React, { VFC } from 'react';
import { Link } from 'gatsby';

const Component: VFC = () => (
  <>
    <Link to='/privacy'>プライバシーポリシー</Link>
    <Link to='/map'>サイトマップ</Link>
  </>
);

export default Component;
